export default __webpack_public_path__ + "static/media/background-desktop.88c07c6b.jpeg";